import {
  Text,
  TokenTextAppearance,
  TextTag,
} from '@volkswagen-onehub/components-core';
import { type ReactElement, type ReactNode } from 'react';

import ButtonIcon from '../ButtonIcon/ButtonIcon';
import Card, { type CardProps } from '../Card/Card';

import Mask, { MaskProps } from '../Mask/Mask';
import { StyledFooter, StyledLinks } from './CardFeaturedItem.styles';

export interface CardFeaturedItemProps extends CardProps {
  decoratorImgContent?: ReactNode;
  maskSize?: MaskProps['size'];
  decoratorImgIcon?: ReactElement;
  onSelect?: () => void;
  price?: ReactNode;
  links?: ReactNode;
  footerStacked?: boolean;
}

const CardFeaturedItem = ({
  price,
  links,
  header,
  decoratorImgContent,
  decoratorImgIcon,
  footerStacked,
  body,
  maskSize = 'medium',
  onSelect = () => {},
  ...restProps
}: CardFeaturedItemProps) => {
  const restMaskProps = {
    ...(decoratorImgIcon
      ? {
          icon: (
            <ButtonIcon onClick={onSelect} icon={decoratorImgIcon} raised />
          ),
        }
      : {}),
  };

  return (
    <Card
      decoratorImg={
        decoratorImgContent ? (
          <Mask size={maskSize} border raised {...restMaskProps}>
            {decoratorImgContent}
          </Mask>
        ) : null
      }
      header={
        <Text tag={TextTag.h3} appearance={TokenTextAppearance.bigcopy200} bold>
          {header}
        </Text>
      }
      footer={
        <StyledFooter stacked={footerStacked}>
          {price && (
            <Text
              tag={TextTag.span}
              appearance={TokenTextAppearance.bigcopy100}
              bold
            >
              {price}
            </Text>
          )}
          {links && <StyledLinks>{links}</StyledLinks>}
        </StyledFooter>
      }
      body={
        body && (
          <Text tag={TextTag.p} appearance={TokenTextAppearance.copy200}>
            {body}
          </Text>
        )
      }
      {...restProps}
    />
  );
};

export default CardFeaturedItem;
